<template>
	<div class="content">
		<el-scrollbar class="sildebar_scroll" :class="{isCollapse:isCollapse}">
			<SidebarItem v-for="(item,index) in asideList" :key="index" :item.sync="item" @onClickItem="onClickItem"/>
		</el-scrollbar>
	</div>
</template>

<script>
	import SidebarItem from "../SidebarItem/SidebarItem.vue"
	export default {
		components: {
			SidebarItem
		},
		props:{
			asideList:{
				type:Array
			}
		},
		data() {
			return {
				isCollapse: true
			};
		},
		methods:{
			onClickItem(e){
				this.asideList.map((item)=>{
					item.checked	= item.rule_id==e.rule_id ? true : false;
					return item;
				})
			}
		}
	}
</script>

<style scoped>
	.content {
		background: var(--auxiliary-color);
		height: 100%;
	}
	.sildebar_scroll.isCollapse {
		width: 66px;
		height: 100%;
	}

	.sildebar_scroll>>>.el-scrollbar__wrap {
		overflow-x: hidden;
	}
</style>